<template>
  <section id="storeDetail" class="pt-2">
    <v-snackbar
      :timeout="5000"
      :value="message.show"
      absolute
      top
      :color="message.type"
    >
      <v-alert :type="message.type" class="mb-0"> {{ message.text }} </v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="message.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-row class="ma-0 px-2">
      <v-spacer></v-spacer>
      <v-btn
        tile
        outlined
        v-if="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
        class="error white--text"
        @click="dialog = true"
        >删除</v-btn
      >
      <v-btn
        tile
        outlined
        v-if="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
        class="success white--text ml-2"
        @click="onSaveStore"
        >保存</v-btn
      >
    </v-row>
    <div id="detailForm">
      <v-form
        class="px-4"
        ref="form"
        v-model="valid"
        lazy-validation
        :readonly="!(user.role?.includes('Sales') || user.role?.includes('Sell-in Sales'))"
      >
      <p class="subtitle-1 font-weight-bold">门店合作进展</p>
        <v-autocomplete
          outlined
          dense
          item-value="id"
          item-text="name"
          :clearable="user.role?.includes('Sales')"
          :items="hzzt"
          label="合作状态"
          v-model="store.collaborateState"
          :rules="[(v) => !!v || '这是必填项']"
        ></v-autocomplete>
        <p class="subtitle-1 font-weight-bold">门店基础信息</p>
        <v-text-field
          outlined
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          dense
          label="门店名称"
          v-model="store.name"
          :rules="[(v) => !!v || '这是必填项']"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          label="电话"
          v-model="store.tel"
          :rules="[(v) => !!v || '这是必填项',
                (v) => testphone(v) || '请输入正确的电话号码或者固话号码！(区号以-分割)']"
        ></v-text-field>
        <v-menu
          v-model="pickDate"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="store.addDate"
              label="开发时间"
              :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
              outlined
              dense
              readonly
              v-bind="attrs"
              :rules="[(v) => !!v || '这是必填项']"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="store.addDate"
            type="month"
            locale="zh"
            @input="pickDate = false"
          ></v-date-picker>
        </v-menu>
        <v-autocomplete
          outlined
          required
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          dense
          label="经销商"
          :rules="[(v) => !!v || '这是必填项']"
          v-model="store.dealerId"
          :items="dealers"
          item-value="id"
          item-text="name"
          @change="onSelectDealer($event)"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          dense
          label="省/直辖市 "
          :items="provinceList"
          item-value="code"
          :rules="[(v) => !!v || '这是必填项']"
          item-text="name"
          v-model="store.provinceCode"
          @change="setProvince($event)"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          dense
          label="市"
          :items="cityList"
          :rules="[(v) => !!v || '这是必填项']"
          item-value="code"
          item-text="name"
          v-model="store.cityCode"
          @change="setCity($event)"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          dense
          label="区"
          v-model="store.districtCode"
          :rules="[(v) => !!v || '这是必填项']"
          :items="districtList"
          item-value="code"
          item-text="name"
          @change="setDistrict($event)"
        ></v-autocomplete>
        <v-textarea
          outlined
          dense
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          label="详细地址"
          height="60"
          v-model="store.address"
          :rules="[(v) => !!v || '这是必填项']"
        ></v-textarea>
        <v-text-field
          outlined
          dense
          label="所属一级经销商"
          v-model="parentDealer"
          readonly
        ></v-text-field>
        <v-autocomplete
          outlined
          dense
          label="门店类型"
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          v-model="store.categoryId"
          item-value="id"
          v-if="store?.collaborateState == 26 || store?.collaborateState == 27"
          item-text="name"
          :items="mdlx"
          :rules="[(v) => !!v || '这是必填项']"
        ></v-autocomplete>
        <v-text-field
          outlined
          dense
          v-if="store?.collaborateState == 26 || store?.collaborateState == 27"
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          label="预计当年博世壁挂炉采购贡献(台)"
          :rules="[
            () =>
              (!!store.yearlySalesCapacity && store.yearlySalesCapacity >= 0) ||
              '请输入大于0的数字',
          ]"
          type="number"
          v-model="store.yearlySalesCapacity"
        ></v-text-field>
        <v-autocomplete
          outlined
          v-if="store?.collaborateState == 26 || store?.collaborateState == 27"
          dense
          label="出样产品"
          item-value="id"
          item-text="name"
          :items="zxjx"
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          multiple
          small-chips
          :rules="[(v) => !!v || '这是必填项']"
          v-model="store.sampleIds"
        ></v-autocomplete>
        <v-radio-group
          row
          class="mt-0"
          v-model="store.isOfficialStore"
          v-if="store?.collaborateState == 26 || store?.collaborateState == 27"
        >
          <v-label>是否官网门店</v-label>
          <v-spacer></v-spacer>
          <v-radio label="是" :value="true"></v-radio>
          <v-radio label="否" :value="false" class="mr-0"></v-radio>
        </v-radio-group>
        <v-radio-group
          row
          class="mt-0"
          v-model="store.isBuildByCompany"
          v-if="store?.collaborateState == 26 || store?.collaborateState == 27"
        >
          <v-label>是否TT投资</v-label>
          <v-spacer></v-spacer>
          <v-radio label="是" :value="true"></v-radio>
          <v-radio label="否" :value="false" class="mr-0"></v-radio>
        </v-radio-group>
        <v-radio-group
          row
          class="mt-0"
          v-model="store.isLightWeight"
          v-if="store?.collaborateState == 26 || store?.collaborateState == 27"
        >
          <v-label>是否轻店</v-label>
          <v-spacer></v-spacer>
          <v-radio label="是" :value="true"></v-radio>
          <v-radio label="否" :value="false" class="mr-0"></v-radio>
        </v-radio-group>
        
      </v-form>
    </div>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">提示</span>
        </v-card-title>
        <v-card-text>
          <span>确认删除吗？</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="onDeleteStore()">
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </section>
</template>

<script>
import { mapState } from "vuex";
import api from "../../api/api";
export default {
  data: () => ({
    loading: false,
    dialog: false,
    valid: false,
    pickDate: false,
    message: {
      show: false,
      type: "success",
      text: "",
    },
    storeId: null,
    store: {
      name: null,
      categoryId: null,
      dealerId: null,
      tel: null,
      region: null,
      provinceCode: null,
      provinceName: null,
      cityCode: null,
      cityName: null,
      districtCode: null,
      districtName: null,
      address: null,
      isOfficialStore: false,
      isBuildByCompany: false,
      isLightWeight: false,
      yearlySalesCapacity: null,
      collaborateState: null,
      sampleIds: null,
      addDate: null,
    },
    hzzt: [],
    mdlx: [],
    zxjx: [],
    dealers: [],
    parentDealer: "",
    provinceList: [],
    cityList: [],
    districtList: [],
    regionCode: "",
  }),
  beforeRouteEnter(to, from, next) {
    let nextFunction = async (vm) => {
      await vm.getCategroy();
      await vm.getRegion();
      if (to.params.id != 0) {
        await vm.getStoreInfo(to.params.id);
      }else{
        await vm.getDisOption();
      }
      
    };
    next(nextFunction);
  },
  computed: {
    ...mapState(["user"]),
    isAdmin() {
      return this.user.role?.includes('HOD') || this.user.role?.includes('RRS') || this.user.role?.includes('SCN');
    },
  },
  methods: {
    testphone(v){
      const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
      if ((!reg.test(v)) && v != ''){
        return false;
      }
      return true;
    },
    setRegion($event) {
      if ($event) {
        const selectedRegion = this.regionList.filter(
          (i) => i.regionCode == $event
        )[0];
        this.getProvince(selectedRegion?.provinces);
      } else {
        this.provinceList = [];
      }
    },
    async getRegion() {
      api.pca
        .getRegion()
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.regionList = data;
            if (!this.isAdmin) {
              this.setRegion(this.user.userRegionCode);
              this.regionCode = this.user.userRegionCode;
            } else if (
              Object.prototype.hasOwnProperty.call(this.$route.query, "region")
            ) {
              this.regionCode = this.$route.query.region;
              this.setRegion(this.regionCode);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProvince(byRegion) {
      if (byRegion) {
        this.provinceList = api.pca.getProvince().filter((i) => {
          return (
            byRegion.filter((pro) => pro.provinceCode === i.code).length > 0
          );
        });
      } else {
        this.provinceList = api.pca.getProvince();
      }
    },
    setProvince($event) {
      const selectedProvince = this.provinceList.filter(
        (i) => i.code == $event
      )[0];
      this.store.provinceName = selectedProvince.name;
      this.cityList = api.pca.getCityByProvince($event);
      this.store.cityCode = null;
      this.store.cityName = null;
      this.store.districtCode = null;
      this.store.districtName = null;
    },
    setCity($event) {
      const selectedCity = this.cityList.filter((i) => i.code == $event)[0];
      this.store.cityName = selectedCity.name;
      this.districtList = this.cityList.filter(
        (i) => i.code == $event
      )[0]?.children;
      this.store.districtCode = null;
      this.store.districtName = null;
    },
    setDistrict($event) {
      const selectedDistrict = this.districtList.filter(
        (i) => i.code == $event
      )[0];
      this.store.districtName = selectedDistrict.name;
    },
    onSelectDealer($event) {
      const dealer = this.dealers.filter((i) => i.id == $event);
      if (dealer?.length) {
        this.parentDealer = dealer[0].parentDealer.name;
      } else {
        this.parentDealer = "";
      }
    },
    async getStoreInfo(id) {
      this.storeId = id;
      this.loading = true;
      api.store
        .getStoreWithId({ id })
        .then((res) => {
          if (res.data.data) {
            this.store = {
              ...res.data.data,
              addDate: res.data.data?.addDate?.slice(0, 7),
              sampleIds: res.data.data?.sampleIds
                ?.split(",")
                ?.map((i) => Number(i)),
            };
            if(this.isAdmin || this.user.role?.includes('RM')){
              this.setRegion(this.store.regionCode);
            }
            if(this.store?.dealer?.parentDealer?.name){
              this.parentDealer = this.store?.dealer?.parentDealer?.name;
            }else if(this.store?.dealer?.name){
              this.parentDealer = this.store?.dealer?.name;
            }
            this.cityList = api.pca.getCityByProvince(this.store.provinceCode);
            this.districtList = this.cityList.filter(
              (i) => i.code == this.store.cityCode
            )[0]?.children;

            this.getDisOption(this.store?.dealer?.regionCode);
          }
        })
        .catch((err) => {
          console.log(err);
          this.message = {
            show: true,
            type: "error",
            text: "数据加载失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    async getCategroy() {
      api.common.getAllCategory().then((res) => {
        const { data, status } = res.data;
        if (data && status == 200) {
          this.mdlx = data.list.filter((i) => i.categoryType == "mdlx");
          this.zxjx = data.list.filter((i) => i.categoryType == "zxjx");
          this.hzzt = data.list.filter((i) => i.categoryType == "hzzt");
        }
      });
    },
    onDeleteStore() {
      this.loading = true;
      api.store
        .deleteStore({
          id: this.storeId,
        })
        .then((res) => {
          if (res.data.status == 200) {
            this.message = {
              show: true,
              type: "success",
              text: "删除成功！",
            };
            setTimeout(() => {
              this.$router.push({
                path: "/store/list",
              });
            }, 1000);
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "删除失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    onSaveStore() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const data = {
        ...this.store,
        addDate: `${this.store.addDate}-01`,
        sampleIds: this.store?.sampleIds?.join(","),
      };
      delete data.category;
      api.store
        .addStore(data)
        .then((res) => {
          if (res.data.status == 0) {
            this.message = {
              show: true,
              type: "success",
              text: "保存成功！",
            };
            this.$router.push({
              path: "/store/list",
            });
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "保存失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
          this.loading = false;
        });
    },
    async getDisOption(regionCode) {
      if(!regionCode){
        regionCode = this.user.userRegionCode;
      }
      api.dealer
        .getDealerList(`/dealer?region=${regionCode}`)
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            const list = data?.list
              ?.filter((i) => !!i.parentDealerId)
              .map((item) => {
                return {
                  ...item,
                  id: Number(item.id),
                };
              });
            this.dealers = list;
          }
        });
    },
  },
};
</script>

<style lang="sass">
#storeDetail
  height: calc(var(--vh, 1vh) * 100 - 48px)
  width: 100%
  #detailForm
    width: 100%
    height: calc(100% - 40px)
    overflow: auto
</style>
